import { render, staticRenderFns } from "./SaveBtnGroup.vue?vue&type=template&id=be8ca722&"
import script from "./SaveBtnGroup.vue?vue&type=script&lang=ts&"
export * from "./SaveBtnGroup.vue?vue&type=script&lang=ts&"
import style0 from "./SaveBtnGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports